import { FC } from "react";
import { PageLayout } from "../layouts/page-layout";

export const Dashboard: FC = () => {
    return <PageLayout title="Dashboard">
        dashboard
    </PageLayout>
}